module.exports = __webpack_public_path__ + "4670a9f9fc17ed77f142ea5d288b0f73.png";